<template>
    <div class="hero__content" :class="{'hero__content--video' : hero_is_video}">
        <div class="hero_img_container">
            <video autoplay muted loop class="hero__deco hero__deco--video" v-if="hero_is_video" >
                <source :src="home_hero_desktop_video" type="video/mp4">
            </video>
            <img v-else class="hero__deco" :src="home_hero_desktop_image"
                 :alt="home_hero_alt">
        </div>
        <div class="purple-circle-container">
            <div class="purple-circle">
                <div class="deux-euro">
                    <h4>2 </h4>
                    <span>€</span>
                </div>
                <p>2 mois</p>
            </div>
        </div>
        <div class="orange-circle-container">
            <div class="orange-circle">
                <p>offre <br> d’essai</p>
            </div>
        </div>
    </div>
</template>

<script>
import image_mixin from "../../_commons/fr/mixins/image_mixin";

export default {
    name: "HomeHero",
    mixins: [
        image_mixin
    ]
}
</script>

<style scoped>

</style>
